exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.actions-custom[data-v-12991e45] {\r\n    padding: 0px 24px 24px;\n}\n.initial-note-textarea[data-v-12991e45] {\r\n    resize: none !important;\n}\n@media screen and (max-width: 768px) {\n.create-mobile-container[data-v-12991e45] {\r\n        max-height: 80%;\n}\n}\r\n", ""]);

// exports
